// import React from 'react';
// import { motion } from 'framer-motion';

// const AboutUs = () => {
//   const fadeIn = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { 
//       opacity: 1, 
//       y: 0,
//       transition: { duration: 0.6 }
//     }
//   };
  
//   const staggerContainer = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2
//       }
//     }
//   };

//   return (
//     <section className="bg-gray-950 overflow-hidden relative py-24">
//       {/* Background decorative elements */}
//       <div className="absolute top-0 left-1/4 w-64 h-64 bg-blue-600/10 rounded-full blur-3xl"></div>
//       <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-emerald-600/10 rounded-full blur-3xl"></div>
      
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//         {/* Section heading */}
//         <motion.div 
//           className="text-center mb-16"
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, margin: "-100px" }}
//           variants={fadeIn}
//         >
//           <h2 className="text-3xl md:text-4xl font-bold mb-4">
//             <span className="bg-gradient-to-r from-blue-400 to-emerald-500 bg-clip-text text-transparent">
//               Who We Are
//             </span>
//           </h2>
//           <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-emerald-600 mx-auto rounded-full mb-6"></div>
//           <p className="text-gray-300 max-w-2xl mx-auto text-lg">
//             Pioneering DevOps excellence with cutting-edge automation tools and innovative 
//             infrastructure solutions since 2018.
//           </p>
//         </motion.div>
        
//         {/* Main content grid */}
//         <div className="grid md:grid-cols-2 gap-16 items-center">
//           {/* Left column - Stats & mission */}
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, margin: "-100px" }}
//             variants={staggerContainer}
//           >
//             {/* Mission statement */}
//             <motion.div 
//               className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 mb-8 shadow-xl"
//               variants={fadeIn}
//             >
//               <h3 className="text-xl font-semibold text-blue-400 mb-3">Our Mission</h3>
//               <p className="text-gray-300">
//                 We empower development teams to build, deploy, and scale applications with 
//                 unprecedented speed and reliability. By automating the complex, we free 
//                 developers to focus on what matters most: creating exceptional software.
//               </p>
//             </motion.div>
            
//             {/* Stats grid */}
//             <motion.div 
//               className="grid grid-cols-2 gap-4"
//               variants={staggerContainer}
//             >
//               {[
//                 { label: "Global Clients", value: "750+", icon: "🌎" },
//                 { label: "Team Members", value: "120", icon: "👥" },
//                 { label: "Deployments Daily", value: "14,000+", icon: "🚀" },
//                 { label: "Uptime SLA", value: "99.99%", icon: "⏱️" }
//               ].map((stat, index) => (
//                 <motion.div 
//                   key={stat.label}
//                   className="bg-gray-900/30 border border-gray-800 rounded-xl p-4 flex flex-col items-center justify-center text-center"
//                   variants={fadeIn}
//                 >
//                   <span className="text-2xl mb-1">{stat.icon}</span>
//                   <span className="text-2xl font-bold text-white">{stat.value}</span>
//                   <span className="text-xs uppercase tracking-wider text-gray-400 mt-1">{stat.label}</span>
//                 </motion.div>
//               ))}
//             </motion.div>
//           </motion.div>
          
//           {/* Right column - Image & core values */}
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, margin: "-100px" }}
//             variants={staggerContainer}
//             className="relative"
//           >
//             {/* Image container */}
//             <motion.div 
//               className="relative mb-8"
//               variants={fadeIn}
//             >
//               <div className="rounded-2xl overflow-hidden shadow-2xl shadow-blue-900/20 border border-blue-700/30">
//                 <div className="aspect-w-16 aspect-h-9">
//                   <div className="bg-gray-800 w-full h-full flex items-center justify-center">
//                     {/* Placeholder for team image - replace src with your actual image */}
//                     <img 
//                       src="/api/placeholder/600/400" 
//                       alt="DevOps team collaboration" 
//                       className="object-cover w-full h-full"
//                     />
//                   </div>
//                 </div>
//               </div>
              
//               {/* Floating accent element */}
//               <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-blue-500 to-emerald-600 p-4 rounded-xl shadow-lg">
//                 <p className="text-white font-medium text-sm">Est. 2018</p>
//               </div>
//             </motion.div>
            
//             {/* Core values */}
//             <motion.div
//               variants={fadeIn}
//               className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
//             >
//               <h3 className="text-xl font-semibold text-blue-400 mb-4">Our Core Values</h3>
//               <ul className="space-y-3">
//                 {[
//                   { title: "Innovation", desc: "Constantly pushing technical boundaries" },
//                   { title: "Reliability", desc: "Building systems you can depend on 24/7/365" },
//                   { title: "Transparency", desc: "Clear communication and honest partnerships" }
//                 ].map((value, i) => (
//                   <li key={value.title} className="flex items-start">
//                     <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-500/20 flex items-center justify-center mt-0.5">
//                       <svg className="h-4 w-4 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
//                       </svg>
//                     </div>
//                     <div className="ml-3">
//                       <p className="text-white font-medium">{value.title}</p>
//                       <p className="text-gray-400 text-sm">{value.desc}</p>
//                     </div>
//                   </li>
//                 ))}
//               </ul>
//             </motion.div>
//           </motion.div>
//         </div>
        
//         {/* Leadership section */}
//         <motion.div 
//           className="mt-24"
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, margin: "-100px" }}
//           variants={fadeIn}
//         >
//           <div className="text-center mb-12">
//             <h2 className="text-2xl md:text-3xl font-bold mb-4">
//               <span className="bg-gradient-to-r from-blue-400 to-emerald-500 bg-clip-text text-transparent">
//                 Our Leadership
//               </span>
//             </h2>
//             <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-600 mx-auto rounded-full mb-4"></div>
//           </div>
          
//           <motion.div 
//             className="grid grid-cols-2 md:grid-cols-4 gap-6"
//             variants={staggerContainer}
//           >
//             {[
//               { name: "Alex Chen", title: "Founder & CEO", photo: "1" },
//               { name: "Sarah Miller", title: "CTO", photo: "2" },
//               { name: "Marcus Johnson", title: "VP of Engineering", photo: "3" },
//               { name: "Priya Sharma", title: "Head of Customer Success", photo: "4" }
//             ].map((leader, index) => (
//               <motion.div 
//                 key={leader.name}
//                 className="text-center"
//                 variants={fadeIn}
//               >
//                 <div className="rounded-xl overflow-hidden border border-gray-800 shadow-lg mb-4 aspect-square">
//                   {/* Replace with actual team member photos */}
//                   <img 
//                     src={`/api/placeholder/200/200`} 
//                     alt={leader.name} 
//                     className="w-full h-full object-cover"
//                   />
//                 </div>
//                 <h4 className="text-white font-semibold">{leader.name}</h4>
//                 <p className="text-blue-400 text-sm">{leader.title}</p>
//               </motion.div>
//             ))}
//           </motion.div>
//         </motion.div>
        
//         {/* Call to action */}
//         <motion.div 
//           className="mt-24 text-center"
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, margin: "-100px" }}
//           variants={fadeIn}
//         >
//           <div className="bg-gradient-to-r from-gray-900 via-gray-900/95 to-gray-900 border border-gray-800 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto shadow-2xl">
//             <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white">Ready to transform your development workflow?</h3>
//             <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
//               Join hundreds of forward-thinking companies that have revolutionized their 
//               deployment process and accelerated their path to innovation.
//             </p>
//             <div className="flex flex-wrap gap-4 justify-center">
//               <a 
//                 href="#"
//                 className="px-8 py-3 bg-gradient-to-r from-blue-600 to-emerald-600 text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-blue-900/30 transition-all duration-300"
//               >
//                 Schedule a Demo
//               </a>
//               <a 
//                 href="#"
//                 className="px-8 py-3 bg-transparent border border-gray-700 text-white rounded-xl font-semibold hover:bg-gray-800 transition-all duration-300"
//               >
//                 View Case Studies
//               </a>
//             </div>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default AboutUs;

import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/devopsabt1.png'
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';
const AboutUs = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };
  
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <div>
    <Header/>
    <section className="bg-gray-950 overflow-hidden relative py-24">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-blue-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-emerald-600/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section heading */}
        <motion.div 
          className="text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeIn}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-blue-400 to-emerald-500 bg-clip-text text-transparent">
              Who We Are
            </span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-emerald-600 mx-auto rounded-full mb-6"></div>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg">
            Pioneering DevOps excellence with cutting-edge automation tools and innovative 
            infrastructure solutions.
          </p>
        </motion.div>
        
        {/* Main content grid */}
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left column - Stats & mission */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {/* Mission statement */}
            <motion.div 
              className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 mb-8 shadow-xl"
              variants={fadeIn}
            >
              <h3 className="text-xl font-semibold text-blue-400 mb-3">Our Mission</h3>
              <p className="text-gray-300">
                We empower development teams to build, deploy, and scale applications with 
                unprecedented speed and reliability. By automating the complex, we free 
                developers to focus on what matters most: creating exceptional software.
              </p>
            </motion.div>
            
             {/* Core values */}
             <motion.div
              variants={fadeIn}
              className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
            >
              <h3 className="text-xl font-semibold text-blue-400 mb-4">Our Core Values</h3>
              <ul className="space-y-3">
                {[
                  { title: "Innovation", desc: "Constantly pushing technical boundaries" },
                  { title: "Reliability", desc: "Building systems you can depend on 24/7" },
                  { title: "Transparency", desc: "Clear communication and honest partnerships" }
                ].map((value, i) => (
                  <li key={value.title} className="flex items-start">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-500/20 flex items-center justify-center mt-0.5">
                      <svg className="h-4 w-4 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <p className="text-white font-medium">{value.title}</p>
                      <p className="text-gray-400 text-sm">{value.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </motion.div>
          </motion.div>
          
          {/* Right column - Image & core values */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
            className="relative"
          >
            {/* Image container */}
            <motion.div 
              className="relative mb-8"
              variants={fadeIn}
            >
              <div className="rounded-2xl overflow-hidden ">
                <div className="aspect-w-16 aspect-h-9">
                  <div className=" w-full h-full flex items-center justify-center">
                    {/* Placeholder for team image - replace src with your actual image */}
                    <img 
                      src={logo} 
                      alt="DevOps team collaboration" 
                      className="object-cover w-full h-full"
                    />
                  </div>
                </div>
              </div>
              
              {/* Floating accent element */}
              {/* <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-blue-500 to-emerald-600 p-4 rounded-xl shadow-lg">
                <p className="text-white font-medium text-sm"></p>
              </div> */}
            </motion.div>
            
           
          </motion.div>
        </div>
        
        {/* Technology Stack Section - Replacing Leadership */}
        <motion.div 
          className="mt-24"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeIn}
        >
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">
              <span className="bg-gradient-to-r from-blue-400 to-emerald-500 bg-clip-text text-transparent">
                Our Technology Stack
              </span>
            </h2>
            <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-emerald-600 mx-auto rounded-full mb-4"></div>
            <p className="text-gray-300 max-w-2xl mx-auto">
              We leverage cutting-edge technologies to deliver scalable, secure, and highly available infrastructure solutions.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Cloud Platforms */}
            <motion.div 
              className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
              variants={fadeIn}
            >
              <div className="h-12 w-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-4">
                <svg className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">Cloud Platforms</h3>
              <p className="text-gray-400 mb-4">
                Multi-cloud expertise across AWS, Google Cloud, and Azure with optimized architecture designs.
              </p>
              <div className="flex flex-wrap gap-2">
                {["AWS", "GCP", "Azure", "DigitalOcean", "Kubernetes"].map(tech => (
                  <span key={tech} className="bg-gray-800 text-blue-400 text-xs py-1 px-2 rounded">
                    {tech}
                  </span>
                ))}
              </div>
            </motion.div>
            
            {/* CI/CD & Automation */}
            <motion.div 
              className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
              variants={fadeIn}
            >
              <div className="h-12 w-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-4">
                <svg className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">CI/CD & Automation</h3>
              <p className="text-gray-400 mb-4">
                Streamlined delivery pipelines with intelligent testing and deployment strategies.
              </p>
              <div className="flex flex-wrap gap-2">
                {["Jenkins", "GitHub Actions", "GitLab CI", "ArgoCD", "Terraform", "Ansible"].map(tech => (
                  <span key={tech} className="bg-gray-800 text-blue-400 text-xs py-1 px-2 rounded">
                    {tech}
                  </span>
                ))}
              </div>
            </motion.div>
            
            {/* Monitoring & Analytics */}
            <motion.div 
              className="bg-gray-900/50 border border-gray-800 backdrop-blur-sm rounded-2xl p-6 shadow-xl"
              variants={fadeIn}
            >
              <div className="h-12 w-12 rounded-full bg-blue-500/20 flex items-center justify-center mb-4">
                <svg className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">Monitoring & Analytics</h3>
              <p className="text-gray-400 mb-4">
                Real-time visibility into system performance with AI-powered anomaly detection.
              </p>
              <div className="flex flex-wrap gap-2">
                {["Prometheus", "Grafana", "ELK Stack", "Datadog", "New Relic", "PagerDuty"].map(tech => (
                  <span key={tech} className="bg-gray-800 text-blue-400 text-xs py-1 px-2 rounded">
                    {tech}
                  </span>
                ))}
              </div>
            </motion.div>
          </div>
        </motion.div>
    
            </div>
            </section>
            <Footer />
            </div>
  )
}

  export default AboutUs